import React, { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import Container from "../global/Container";
import Context from "../../context";
import './DocsPermissions.scss';
import ListTitle from "../global/ListTitle";
import { useLocation } from "react-router-dom";
import { getBackPath } from "../../helpers";
import TextInput from "../global/TextInput";
import Switch from '@mui/material/Switch';
import Button from "../global/Buttons/Button";

const DocsPermissions = ({ docId }) => {
  const { viewMode, customHistory, itin, setItin } = useContext(Context);
  const filteredClients = useMemo(() => {
    return itin.clients?.filter(client => client.id !== itin?.localData?.client?.id);
  }, [itin?.clients, itin?.localData?.client?.id]);

  const [docData, setDocData] = useState(true);
  const [docTitle, setDocTitle] = useState('');
  const [restrictedClientIds, setRestrictedClientIds] = useState([]);
  const [shareWithEveryone, setShareWithEveryone] = useState(false);
  const [backButtonPath, setBackButtonPath] = useState(-1);
  const location = useLocation();
  // const { docId } = useParams();
  const backButton = useRef(null);
  const debounceTimeout = useRef(null);

  const updateAndSyncDocTitle = newTitle => {
    const updatedDocs = itin.documents.map(doc => doc.id === docData.id ? { ...doc, name: newTitle } : doc);

    setItin(prevItin => {
      return {
        ...prevItin,
        documents: updatedDocs,
      }
    })
  };

  useLayoutEffect(() => {
    const backPath = getBackPath(location.pathname, customHistory, docId ? 2 : null);
    setBackButtonPath(backPath);
  }, [customHistory, docId, location.pathname]);

  useEffect(() => {
    const data = itin.documents.find(doc => doc.id === parseInt(docId));
    setDocTitle(data.name);
    setDocData(data);
    setRestrictedClientIds(data?.meta?.restricted_to_traveller_ids || []);

    return () => {
      setDocTitle('');
    };
  }, [docId, itin.documents]);

  const handleChangeItem = (checked, id) => {
    setRestrictedClientIds(prevState =>
      checked
        ? [...prevState, id]
        : prevState.filter(x => x !== id)
    );
  };

  const handleChangeShareWithEveryone = () => {
    setShareWithEveryone(!shareWithEveryone);
    setRestrictedClientIds(shareWithEveryone ? [] : filteredClients.map(client => client.id));
  };

  const handleDocTitleChange = e => {
    const newTitle = e.target.value;
    setDocTitle(newTitle);

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      updateAndSyncDocTitle(newTitle);
    }, 2000);
  };

  // TODO translation for titles and Share with everyone
  return (
    <Container className="container-my-documents" mainElementClassName={`documents documents-${viewMode}`}
               closePath={customHistory[customHistory.length + backButtonPath - 1] || `/${itin.localData.urlKey}/my-documents`}
               docScreenName={docData.name}>
      {viewMode === 'desktop' &&
        <ListTitle backButton={backButton} backButtonPath={backButtonPath} docScreenName={docData.name} />}
      <div className="my-document-block-container">
        <span className="title">Document title</span>
        <TextInput
          className="border-grey full-width"
          value={docTitle}
          onChange={ handleDocTitleChange }
        />
      </div>
      <div className="my-document-block-container">
        <span className="title">Share this document with the following people</span>
        <ul>
          <li tabIndex="0">
            <div className="item-container">
              <span>Share with everyone</span>
              <Switch
                checked={shareWithEveryone}
                color="warning"
                inputProps={{ "aria-label": "controlled", tabIndex: 0 }}
                onChange={handleChangeShareWithEveryone}
                onKeyDown={(e) => e.key === 'Enter' ? handleChangeShareWithEveryone() : null}
              />
            </div>
          </li>
          {!shareWithEveryone && filteredClients.map((x, i) => (
              <li key={i} tabIndex="0">
                {
                  <div className="item-container">
                    <span>{x?.fullname}</span>
                    <Switch
                      checked={!!restrictedClientIds.includes(x.id)}
                      color="warning"
                      inputProps={{ "aria-label": "controlled", tabIndex: 0 }}
                      onChange={(e) => handleChangeItem(e.target.checked, x.id)}
                      onKeyDown={(e) => e.key === 'Enter'? handleChangeItem(!e.target.checked, x.id) : null}
                    />
                  </div>
                }
              </li>
            ))
          }
        </ul>
      </div>
      <div className="my-document-block-container extra-top-padding">
        <span className="title">Delete document</span>
        <Button onClick={() => console.log('renderUploadHintBlock')}>Permanently delete document</Button>
      </div>
    </Container>
  )
}

export default DocsPermissions;
